import styled from "@emotion/styled";

import { theme } from "../../../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const Root = styled.div(props => ({
    fontSize: "18px",
    textAlign: "center",
    color: theme(props).typography.inactive.color,
}));

export const UnitLoaderBefore = styled.div({
    display: "inline-block",
    height: "100%",
    verticalAlign: "middle",
});
